import React from 'react';

function OperatorLayout({ children }) {
    return (
        <div style={{
            display: 'flex',
            minHeight: '100vh',
            width: '100%',
            background: '#F7FAFC',
            margin: 0,
            padding: 0
        }}>
            <main style={{
                flexGrow: 1,
                width: '100%'
            }}>
                {children}
            </main>
        </div>
    );
}

export default OperatorLayout;